// import { useEffect, useState, useRef, useCallback } from "react";
// import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
// import IPDCFinalTable from "../../../../../components/IPDCFinalTable";
// import { Box } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import Button from "@mui/material/Button";
// import MapIcon from "@mui/icons-material/Map";
// import { ToastContainer, toast } from "react-toastify";
// import { UpdateAndGetResponse } from "../../../../../services/api/ExecuteApiRequests";

// export default function ApproveImportedSpatialInfo() {
//   const [unapprovedData, setUnapprovedData] = useState([]);
//   const [unapprovedSplitAndMergeData, setUnapprovedSplitAndMergeData] = useState([]);
//   const componentRef = useRef();
//   const [selectedColumnsImport, setSelectedColumnsImport] = useState([]);
//   const [selectedColumnsSplitMerge, setSelectedColumnsSplitMerge] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingRows, setLoadingRows] = useState({}); // Track loading state per row

//   const navigate = useNavigate();

//   // Utility: convert nested objects to strings
//   const stringifyNestedObjects = (dataArray) => {
//     if (!dataArray || !Array.isArray(dataArray)) return [];
    
//     return dataArray.map(item => {
//       const newItem = {};
//       Object.keys(item).forEach(key => {
//         newItem[key] = (typeof item[key] === "object" && item[key] !== null)
//           ? JSON.stringify(item[key])
//           : item[key];
//       });
//       return newItem;
//     });
//   };

//   // Handle navigation to map view with specific parcel data
//   const handleGoToMap = useCallback((row) => {
//     console.log("📍 CLICKED ROW DATA:", row);
//     console.log("📍 Row ID:", row.id);
//     console.log("📍 Operation Type:", row.type_of_edit);
//     console.log("📍 Original UPIN:", row.original_upin);
//     console.log("📍 Merged UPINs:", row.merged_upins);
    
//     // Prepare the data to pass to map view
//     const mapData = {
//       id: row.id,
//       type: "splitMerge",
//       operationType: row.type_of_edit,
//       rowData: row,
//       spatialData: row.spatial_data || row.geometry || row.parcel_data,
//       originalParcels: row.original_parcels,
//       newParcels: row.new_parcels,
//       parkeId: row.park_id,
//     };

//     console.log("📍 Map Data being sent:", mapData);

//     // Navigate to map view with state
//     navigate("/ViewUnapprovedSplitAndMergeMap", { 
//       state: { 
//         highlightParcel: mapData,
//         source: "splitMerge"
//       }
//     });
//   }, [navigate]);

//   // Add action columns for IMPORT data - only verify and decline buttons
//   const addActionColumnsImport = useCallback((dataArray) => {
//     if (!dataArray || !Array.isArray(dataArray)) return [];
    
//     return dataArray.map(item => ({
//       ...item,
//       verify: (
//         <Button 
//           variant="contained" 
//           color="success" 
//           size="small"
//           onClick={() => handleApproveImport(item)}
//           disabled={loadingRows[item.id] === 'approve'}
//           sx={{ whiteSpace: 'nowrap', minWidth: '80px' }}
//         >
//           {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
//         </Button>
//       ),
//       decline: (
//         <Button 
//           variant="contained" 
//           color="error" 
//           size="small"
//           onClick={() => handleDeclineImport(item)}
//           disabled={loadingRows[item.id] === 'decline'}
//           sx={{ whiteSpace: 'nowrap', minWidth: '80px' }}
//         >
//           {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
//         </Button>
//       )
//     }));
//   }, [loadingRows]);

//   // Add action columns for SPLIT/MERGE data - view map, verify, and decline buttons
//   const addActionColumnsSplitMerge = useCallback((dataArray) => {
//     if (!dataArray || !Array.isArray(dataArray)) return [];
    
//     return dataArray.map(item => ({
//       ...item,
//       viewMap: (
//         <Button 
//           variant="outlined" 
//           color="primary" 
//           size="small"
//           startIcon={<MapIcon />}
//           onClick={() => handleGoToMap(item)}
//           title="View map with highlighted parcels"
//           sx={{ whiteSpace: 'nowrap', minWidth: '100px' }}
//         >
//           View Map
//         </Button>
//       ),
//       verify: (
//         <Button 
//           variant="contained" 
//           color="success" 
//           size="small"
//           onClick={() => handleApprove(item)}
//           disabled={loadingRows[item.id] === 'approve'}
//           sx={{ 
//             whiteSpace: 'nowrap',
//             bgcolor: '#f5f5f5',
//             color: '#000',
//             '&:hover': {
//               bgcolor: '#e0e0e0',
//             }
//           }}
//         >
//           {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
//         </Button>
//       ),
//       decline: (
//         <Button 
//           variant="contained" 
//           color="error" 
//           size="small"
//           onClick={() => handleDecline(item)}
//           disabled={loadingRows[item.id] === 'decline'}
//           sx={{ 
//             whiteSpace: 'nowrap',
//             backgroundColor: '#f5f5f5', // Light gray background (same as Approve button)
//             color: '#d32f2f', // Red text color
//             '&:hover': {
//               backgroundColor: '#e0e0e0', // Slightly darker gray on hover
//               color: '#b71c1c', // Darker red on hover
//             },
//             '&:disabled': {
//               backgroundColor: '#f5f5f5',
//               color: '#d32f2f',
//               opacity: 0.6,
//             }
//           }}
//         >
//           {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
//         </Button>
//       )
//     }));
//   }, [loadingRows, handleGoToMap]);

//   // Handler functions for IMPORT data - INDIVIDUAL ROW APPROVAL
//   const handleApproveImport = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
//     try {
//       const result = await UpdateAndGetResponse(`imports/approveSingle/${row.id}`);
//       if (result) {
//         toast.success("Spatial data import verified successfully!", { 
//           position: "top-right",
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });
        
//         // Remove only the approved row from the table
//         setUnapprovedData(prevData => 
//           prevData.filter(item => item.id !== row.id)
//         );
//       } else {
//         toast.error("Failed to verify spatial data import! Please try again.", { 
//           position: "top-right",
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });
//       }
//     } catch (error) {
//       toast.error("Failed to verify spatial data import! Please try again.", { 
//         position: "top-right",
//         autoClose: 8000,
//         pauseOnHover: true,
//         closeOnClick: false
//       });
//       console.log(error);
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   const handleDeclineImport = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
//     try {
//       console.log("handle decline import clicked for row:", row.id);
//       const result = await UpdateAndGetResponse(`imports/declineSingle/${row.id}`);
//       console.log(result);
//       if (result) {
//         toast.success("Spatial data import declined successfully!", { 
//           position: "top-right",
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });
        
//         // Remove only the declined row from the table
//         setUnapprovedData(prevData => 
//           prevData.filter(item => item.id !== row.id)
//         );
//       } else {
//         toast.error("Failed to decline spatial data import! Please try again.", { 
//           position: "top-right",
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });
//       }
//     } catch (error) {
//       toast.error("Failed to decline spatial data import! Please try again.", { 
//         position: "top-right",
//         autoClose: 8000,
//         pauseOnHover: true,
//         closeOnClick: false
//       });
//       console.log(error);
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   // Handler functions for SPLIT/MERGE data - INDIVIDUAL ROW APPROVAL
//   const handleApprove = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
//     try {
//       // Use the new individual approval endpoint
//       const result = await UpdateAndGetResponse(`/splitAndMerge/verifySingle/${row.id}`);

//       if (result) {
//         console.log(result)
//         // Determine message based on operation type from result status
//         const message = result.status === 'Splited' 
//           ? "Parcel split verified successfully" 
//           : result.status === 'Merged'
//           ? "Parcel merge verified successfully"
//           : "Parcel operation verified successfully";
        
//         toast.success(message, { 
//           position: "top-right", 
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });

//         // Remove only the approved row from the table
//         setUnapprovedSplitAndMergeData(prevData => 
//           prevData.filter(item => item.id !== row.id)
//         );
//       } else {
//         // Determine error message based on operation type from row data
//         const errorMessage = row.type_of_edit === 'SPLIT' 
//           ? "Parcel split verification failed!" 
//           : "Parcel merge verification failed!";
        
//         toast.error(errorMessage, { 
//           position: "top-right", 
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });
//       }
//     } catch (error) {
//       // Determine error message based on operation type from row data
//       const errorMessage = row.type_of_edit === 'SPLIT' 
//         ? "Parcel split verification failed!" 
//         : "Parcel merge verification failed!";
      
//       toast.error(errorMessage, { 
//         position: "top-right", 
//         autoClose: 8000,
//         pauseOnHover: true,
//         closeOnClick: false
//       });
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   const handleDecline = async (row) => {
//     setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
//     try {
//       const result = await UpdateAndGetResponse(`splitAndMerge/declineSingle/${row.id}`);
      
//       if (result) {
//         toast.success("Parcel operation declined", { 
//           position: "top-right", 
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });

//         // Remove only the declined row from the table
//         setUnapprovedSplitAndMergeData(prevData => 
//           prevData.filter(item => item.id !== row.id)
//         );
//       } else {
//         toast.error("Parcel decline failed!", { 
//           position: "top-right", 
//           autoClose: 8000,
//           pauseOnHover: true,
//           closeOnClick: false
//         });
//       }
//     } catch (error) {
//       toast.error("Parcel decline failed!", { 
//         position: "top-right", 
//         autoClose: 8000,
//         pauseOnHover: true,
//         closeOnClick: false
//       });
//       console.log(error);
//     } finally {
//       setLoadingRows(prev => ({ ...prev, [row.id]: null }));
//     }
//   };

//   useEffect(() => {
//     const fetchAllData = async () => {
//       setLoading(true);
      
//       try {
//         // Fetch Unapproved Import Data
//         const importResult = await GetDataFromApiWithParams("unapprovedSpatialData");
//         if (importResult && Array.isArray(importResult) && importResult.length > 0) {
//           const formattedImportData = stringifyNestedObjects(importResult);
//           const importDataWithActions = addActionColumnsImport(formattedImportData);
//           setUnapprovedData(importDataWithActions);
          
//           // Get base columns (excluding action columns that will be added by IPDCFinalTable)
//           const baseImportColumns = formattedImportData.length > 0 
//             ? Object.keys(formattedImportData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
//             : [];
          
//           // Set columns for import data: only verify and decline
//           setSelectedColumnsImport([...baseImportColumns, "verify", "decline"]);
//           console.log("Fetched unapprovedData:", importDataWithActions);
//         } else {
//           console.log("No unapproved import data found");
//           setUnapprovedData([]);
//         }

//         // Fetch Unapproved Split/Merge Data
//         const splitMergeResult = await GetDataFromApiWithParams("unapprovedSplitAndMergeData");
//         if (splitMergeResult && Array.isArray(splitMergeResult) && splitMergeResult.length > 0) {
//           const formattedSplitMergeData = stringifyNestedObjects(splitMergeResult);
//           const splitMergeDataWithActions = addActionColumnsSplitMerge(formattedSplitMergeData);
//           setUnapprovedSplitAndMergeData(splitMergeDataWithActions);
          
//           // Get base columns (excluding action columns that will be added by IPDCFinalTable)
//           const baseSplitMergeColumns = formattedSplitMergeData.length > 0 
//             ? Object.keys(formattedSplitMergeData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
//             : [];
          
//           // Set columns for split/merge data: viewMap, verify, and decline
//           setSelectedColumnsSplitMerge([...baseSplitMergeColumns, "viewMap", "verify", "decline"]);
//           console.log("Fetched unapprovedSplitAndMergeData:", splitMergeDataWithActions);
//         } else {
//           console.log("No unapproved split/merge data found");
//           setUnapprovedSplitAndMergeData([]);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         toast.error("Failed to load data. Please try again.", {
//           position: "top-right",
//           autoClose: 8000
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllData();
//   }, [addActionColumnsImport, addActionColumnsSplitMerge]);

//   return (
//     <Box sx={{ p: 2 }}>
//       <ToastContainer 
//         position="top-right"
//         autoClose={8000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick={false}
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//       />
      
//       {loading ? (
//         <div style={{ textAlign: 'center', padding: '20px' }}>Loading data...</div>
//       ) : (
//         <>
//           {/* Unapproved Import Data Section */}
//           <div style={{ marginBottom: '30px' }}>
//             <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Import Data</h3>
            
//             {unapprovedData.length > 0 ? (
//               <IPDCFinalTable
//                 ref={componentRef}
//                 data={unapprovedData}
//                 setData={setUnapprovedData}
//                 selectedColumns={selectedColumnsImport}
//                 title="Unapproved Import Data"
//                 attachmentLink="file_path"
//                 hasAttachment={true}
//               />
//             ) : (
//               <div style={{ 
//                 padding: '20px', 
//                 backgroundColor: '#f5f5f5', 
//                 borderRadius: '4px',
//                 textAlign: 'center',
//                 color: '#666',
//                 marginBottom: '20px'
//               }}>
//                 No Import Data to approve
//               </div>
//             )}
//           </div>

//           {/* Separator */}
//           <div style={{ 
//             borderBottom: '2px solid #e0e0e0', 
//             margin: '30px 0',
//             width: '100%' 
//           }} />

//           {/* Unapproved Split/Merge Data Section */}
//           <div>
//             <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Split/Merge Data</h3>
            
//             {unapprovedSplitAndMergeData.length > 0 ? (
//               <IPDCFinalTable
//                 ref={componentRef}
//                 data={unapprovedSplitAndMergeData}
//                 setData={setUnapprovedSplitAndMergeData}
//                 selectedColumns={selectedColumnsSplitMerge}
//                 title="Unapproved Split and Merge Data"
//                 attachmentLink="file_path"
//                 hasAttachment={false}
//               />
//             ) : (
//               <div style={{ 
//                 padding: '20px', 
//                 backgroundColor: '#f5f5f5', 
//                 borderRadius: '4px',
//                 textAlign: 'center',
//                 color: '#666'
//               }}>
//                 No Split/Merge Data to approve
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </Box>
//   );
// }

import { useEffect, useState, useRef, useCallback } from "react";
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../../components/IPDCFinalTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import MapIcon from "@mui/icons-material/Map";
import { ToastContainer, toast } from "react-toastify";
import { UpdateAndGetResponse } from "../../../../../services/api/ExecuteApiRequests";

export default function ApproveImportedSpatialInfo() {
  const [unapprovedData, setUnapprovedData] = useState([]);
  const [unapprovedSplitAndMergeData, setUnapprovedSplitAndMergeData] = useState([]);
  const componentRef = useRef();
  const [selectedColumnsImport, setSelectedColumnsImport] = useState([]);
  const [selectedColumnsSplitMerge, setSelectedColumnsSplitMerge] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingRows, setLoadingRows] = useState({});
  const [parksData, setParksData] = useState(null);
  const [isLoadingParks, setIsLoadingParks] = useState(true);

  const navigate = useNavigate();

  // Fetch parks data ONCE when component mounts
  useEffect(() => {
    const loadParksData = async () => {
      try {
        console.log("Loading parks data...");
        // Try different possible endpoints for parks
        let parks = null;
        
        try {
          parks = await GetDataFromApiWithParams("parks");
        } catch (e) {
          console.log("Failed to load from 'parks', trying 'getAllParks'");
        }
        
        if (!parks) {
          try {
            parks = await GetDataFromApiWithParams("getAllParks");
          } catch (e) {
            console.log("Failed to load from 'getAllParks'");
          }
        }
        
        if (!parks) {
          try {
            parks = await GetDataFromApiWithParams("parkList");
          } catch (e) {
            console.log("Failed to load from 'parkList'");
          }
        }
        
        if (parks && Array.isArray(parks) && parks.length > 0) {
          console.log("Parks loaded successfully:", parks.length);
          setParksData(parks);
        } else {
          console.warn("No parks data available, creating fallback");
          // Create a fallback park object if no parks are found
          setParksData([{
            id: "default-park-id",
            park_id: "default-park-id",
            name: "Default Park",
            geometry: null
          }]);
        }
      } catch (error) {
        console.error("Error loading parks:", error);
        // Create fallback park data
        setParksData([{
          id: "fallback-park-id",
          park_id: "fallback-park-id",
          name: "Fallback Park",
          geometry: null
        }]);
      } finally {
        setIsLoadingParks(false);
      }
    };
    
    loadParksData();
  }, []);

  // Utility: convert nested objects to strings
  const stringifyNestedObjects = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => {
      const newItem = {};
      Object.keys(item).forEach(key => {
        newItem[key] = (typeof item[key] === "object" && item[key] !== null)
          ? JSON.stringify(item[key])
          : item[key];
      });
      return newItem;
    });
  };

  // Handle navigation to map view with specific parcel data
  const handleGoToMap = useCallback((row) => {
    console.log("📍 CLICKED ROW DATA:", row);
    
    // Check if parks data is loaded
    if (!parksData) {
      toast.error("Park data not loaded yet. Please try again.", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    try {
      // Get park ID from row or use first park's ID
      let parkId = row.park_id || row.parkeId;
      
      // Find the matching park or use first park
      let selectedPark = null;
      
      if (parkId) {
        selectedPark = parksData.find(p => 
          p.id === parkId || p.park_id === parkId || p.parkeId === parkId
        );
      }
      
      // If no matching park found, use the first park
      if (!selectedPark && parksData.length > 0) {
        selectedPark = parksData[0];
        parkId = selectedPark.id || selectedPark.park_id || selectedPark.parkeId;
        console.log("Using default park:", parkId);
      }
      
      if (!selectedPark) {
        toast.error("No park data available", {
          position: "top-right",
          autoClose: 5000,
        });
        return;
      }

      // Prepare the data with explicit park information
      const mapData = {
        id: row.id,
        type: "splitMerge",
        operationType: row.type_of_edit,
        rowData: row,
        spatialData: row.spatial_data || row.geometry || row.parcel_data,
        originalParcels: row.original_parcels,
        newParcels: row.new_parcels,
        parkId: parkId,
        parkeId: parkId,
        park_id: parkId,
        // Include the full parks array
        parks: parksData,
        // Include the selected park explicitly
        selectedPark: selectedPark
      };

      console.log("📍 Map Data being sent:", mapData);

      // Navigate with complete park data
      navigate("/ViewUnapprovedSplitAndMergeMap", { 
        state: { 
          highlightParcel: mapData,
          source: "splitMerge",
          parkId: parkId,
          // Pass the full parks array to prevent the fetchParks call
          parks: parksData,
          // Pass a flag to skip park fetching
          skipParkFetch: true
        }
      });
    } catch (error) {
      console.error("Error in handleGoToMap:", error);
      toast.error("Failed to load map view", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  }, [navigate, parksData]);

  // Add action columns for IMPORT data - with updated button styling
  const addActionColumnsImport = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      verify: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleApproveImport(item)}
          disabled={loadingRows[item.id] === 'approve'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            bgcolor: '#f5f5f5',
            color: '#000',
            '&:hover': {
              bgcolor: '#e0e0e0',
            }
          }}
        >
          {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
        </Button>
      ),
      decline: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleDeclineImport(item)}
          disabled={loadingRows[item.id] === 'decline'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            backgroundColor: '#f5f5f5',
            color: '#d32f2f',
            '&:hover': {
              backgroundColor: '#e0e0e0',
              color: '#b71c1c',
            },
            '&:disabled': {
              backgroundColor: '#f5f5f5',
              color: '#d32f2f',
              opacity: 0.6,
            }
          }}
        >
          {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
        </Button>
      )
    }));
  }, [loadingRows]);

  // Add action columns for SPLIT/MERGE data - with updated button styling
  const addActionColumnsSplitMerge = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      viewMap: (
        <Button 
          variant="outlined" 
          color="primary" 
          size="small"
          startIcon={<MapIcon />}
          onClick={() => handleGoToMap(item)}
          title="View map with highlighted parcels"
          sx={{ whiteSpace: 'nowrap', minWidth: '100px' }}
          disabled={isLoadingParks || !parksData}
        >
          {isLoadingParks ? "Loading..." : "View Map"}
        </Button>
      ),
      verify: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleApprove(item)}
          disabled={loadingRows[item.id] === 'approve'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            bgcolor: '#f5f5f5',
            color: '#000',
            '&:hover': {
              bgcolor: '#e0e0e0',
            }
          }}
        >
          {loadingRows[item.id] === 'approve' ? "Processing..." : "Verify"}
        </Button>
      ),
      decline: (
        <Button 
          variant="contained" 
          size="small"
          onClick={() => handleDecline(item)}
          disabled={loadingRows[item.id] === 'decline'}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '80px',
            backgroundColor: '#f5f5f5',
            color: '#d32f2f',
            '&:hover': {
              backgroundColor: '#e0e0e0',
              color: '#b71c1c',
            },
            '&:disabled': {
              backgroundColor: '#f5f5f5',
              color: '#d32f2f',
              opacity: 0.6,
            }
          }}
        >
          {loadingRows[item.id] === 'decline' ? "Processing..." : "Decline"}
        </Button>
      )
    }));
  }, [loadingRows, handleGoToMap, isLoadingParks, parksData]);

  // Handler functions for IMPORT data
  const handleApproveImport = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
    try {
      const result = await UpdateAndGetResponse(`imports/approveSingle/${row.id}`);
      if (result) {
        toast.success("Spatial data import verified successfully!", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
        
        setUnapprovedData(prevData => 
          prevData.filter(item => item.id !== row.id)
        );
      } else {
        toast.error("Failed to verify spatial data import! Please try again.", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
      }
    } catch (error) {
      toast.error("Failed to verify spatial data import! Please try again.", { 
        position: "top-right",
        autoClose: 8000,
        pauseOnHover: true,
        closeOnClick: false
      });
      console.log(error);
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  const handleDeclineImport = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
    try {
      const result = await UpdateAndGetResponse(`imports/declineSingle/${row.id}`);
      if (result) {
        toast.success("Spatial data import declined successfully!", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
        
        setUnapprovedData(prevData => 
          prevData.filter(item => item.id !== row.id)
        );
      } else {
        toast.error("Failed to decline spatial data import! Please try again.", { 
          position: "top-right",
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
      }
    } catch (error) {
      toast.error("Failed to decline spatial data import! Please try again.", { 
        position: "top-right",
        autoClose: 8000,
        pauseOnHover: true,
        closeOnClick: false
      });
      console.log(error);
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  // Handler functions for SPLIT/MERGE data
  const handleApprove = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'approve' }));
    try {
      const result = await UpdateAndGetResponse(`/splitAndMerge/verifySingle/${row.id}`);

      if (result) {
        console.log(result)
        const message = result.status === 'Splited' 
          ? "Parcel split verified successfully" 
          : result.status === 'Merged'
          ? "Parcel merge verified successfully"
          : "Parcel operation verified successfully";
        
        toast.success(message, { 
          position: "top-right", 
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });

        setUnapprovedSplitAndMergeData(prevData => 
          prevData.filter(item => item.id !== row.id)
        );
      } else {
        const errorMessage = row.type_of_edit === 'SPLIT' 
          ? "Parcel split verification failed!" 
          : "Parcel merge verification failed!";
        
        toast.error(errorMessage, { 
          position: "top-right", 
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
      }
    } catch (error) {
      const errorMessage = row.type_of_edit === 'SPLIT' 
        ? "Parcel split verification failed!" 
        : "Parcel merge verification failed!";
      
      toast.error(errorMessage, { 
        position: "top-right", 
        autoClose: 8000,
        pauseOnHover: true,
        closeOnClick: false
      });
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  const handleDecline = async (row) => {
    setLoadingRows(prev => ({ ...prev, [row.id]: 'decline' }));
    try {
      const result = await UpdateAndGetResponse(`splitAndMerge/declineSingle/${row.id}`);
      
      if (result) {
        toast.success("Parcel operation declined", { 
          position: "top-right", 
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });

        setUnapprovedSplitAndMergeData(prevData => 
          prevData.filter(item => item.id !== row.id)
        );
      } else {
        toast.error("Parcel decline failed!", { 
          position: "top-right", 
          autoClose: 8000,
          pauseOnHover: true,
          closeOnClick: false
        });
      }
    } catch (error) {
      toast.error("Parcel decline failed!", { 
        position: "top-right", 
        autoClose: 8000,
        pauseOnHover: true,
        closeOnClick: false
      });
      console.log(error);
    } finally {
      setLoadingRows(prev => ({ ...prev, [row.id]: null }));
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      
      try {
        const importResult = await GetDataFromApiWithParams("unapprovedSpatialData");
        if (importResult && Array.isArray(importResult) && importResult.length > 0) {
          const formattedImportData = stringifyNestedObjects(importResult);
          const importDataWithActions = addActionColumnsImport(formattedImportData);
          setUnapprovedData(importDataWithActions);
          
          const baseImportColumns = formattedImportData.length > 0 
            ? Object.keys(formattedImportData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
            : [];
          
          setSelectedColumnsImport([...baseImportColumns, "verify", "decline"]);
        } else {
          setUnapprovedData([]);
        }

        const splitMergeResult = await GetDataFromApiWithParams("unapprovedSplitAndMergeData");
        if (splitMergeResult && Array.isArray(splitMergeResult) && splitMergeResult.length > 0) {
          const formattedSplitMergeData = stringifyNestedObjects(splitMergeResult);
          const splitMergeDataWithActions = addActionColumnsSplitMerge(formattedSplitMergeData);
          setUnapprovedSplitAndMergeData(splitMergeDataWithActions);
          
          const baseSplitMergeColumns = formattedSplitMergeData.length > 0 
            ? Object.keys(formattedSplitMergeData[0]).filter(col => !['verify', 'decline', 'viewMap'].includes(col))
            : [];
          
          setSelectedColumnsSplitMerge([...baseSplitMergeColumns, "viewMap", "verify", "decline"]);
        } else {
          setUnapprovedSplitAndMergeData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load data. Please try again.", {
          position: "top-right",
          autoClose: 8000
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [addActionColumnsImport, addActionColumnsSplitMerge]);

  // Show loading while parks are being fetched
  if (isLoadingParks || loading) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <div>Loading data...</div>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <ToastContainer 
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <>
        {/* Unapproved Import Data Section */}
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Import Data</h3>
          
          {unapprovedData.length > 0 ? (
            <IPDCFinalTable
              ref={componentRef}
              data={unapprovedData}
              setData={setUnapprovedData}
              selectedColumns={selectedColumnsImport}
              title="Unapproved Import Data"
              attachmentLink="file_path"
              hasAttachment={true}
            />
          ) : (
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f5f5f5', 
              borderRadius: '4px',
              textAlign: 'center',
              color: '#666',
              marginBottom: '20px'
            }}>
              No Import Data to approve
            </div>
          )}
        </div>

        {/* Separator */}
        <div style={{ 
          borderBottom: '2px solid #e0e0e0', 
          margin: '30px 0',
          width: '100%' 
        }} />

        {/* Unapproved Split/Merge Data Section */}
        <div>
          <h3 style={{ marginBottom: '15px', color: '#333' }}>Unapproved Split/Merge Data</h3>
          
          {unapprovedSplitAndMergeData.length > 0 ? (
            <IPDCFinalTable
              ref={componentRef}
              data={unapprovedSplitAndMergeData}
              setData={setUnapprovedSplitAndMergeData}
              selectedColumns={selectedColumnsSplitMerge}
              title="Unapproved Split and Merge Data"
              attachmentLink="file_path"
              hasAttachment={false}
            />
          ) : (
            <div style={{ 
              padding: '20px', 
              backgroundColor: '#f5f5f5', 
              borderRadius: '4px',
              textAlign: 'center',
              color: '#666'
            }}>
              No Split/Merge Data to approve
            </div>
          )}
        </div>
      </>
    </Box>
  );
}